import * as types from '../mutation-types';
const state = {
  LoginObj: {
    loginName: '',
    userId: '',
    userName: '',
    userType: '',
  },
};
const getters = {
  getLogin: (state) => state.LoginObj,
};
const actions = {
  async getLoginId({ commit }, obj) {
    commit(types.GET_LOGIN_STATUS, obj);
  },
};
const mutations = {
  [types.GET_LOGIN_STATUS](state, obj) {
    state.LoginObj = obj;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
